import { render, staticRenderFns } from "./JobCategoryList.vue?vue&type=template&id=f6f97402&"
import script from "./JobCategoryList.vue?vue&type=script&lang=js&"
export * from "./JobCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports